import { useState, useEffect, useCallback, useMemo } from 'react';
import Countdown from './Countdown';
// Temporarily disabled - will reactivate later
// import ResponsiveFrame4 from './ResponsiveFrame4';
// import OrientationPrompt from './OrientationPrompt';

/**
 * Parse and validate the countdown target date from environment variable
 */
function getTargetDate(): Date | null {
  // Use env variable, or default to null (no countdown)
  const dateString = import.meta.env.VITE_COUNTDOWN_DATE;
  
  // No date configured
  if (!dateString) return null;
  
  const targetDate = new Date(dateString);
  
  // Invalid date
  if (isNaN(targetDate.getTime())) {
    console.error('Invalid VITE_COUNTDOWN_DATE format:', dateString);
    return null;
  }
  
  return targetDate;
}

/**
 * Check if countdown should be active based on target date
 */
function isCountdownActive(targetDate: Date | null): boolean {
  if (!targetDate) return false;
  return new Date() < targetDate;
}

function App() {
  const targetDate = useMemo(() => getTargetDate(), []);
  const [showCountdown, setShowCountdown] = useState(() => isCountdownActive(targetDate));

  // Re-check countdown status on mount (in case of SSR/hydration)
  useEffect(() => {
    setShowCountdown(isCountdownActive(targetDate));
  }, [targetDate]);

  // Handle countdown expiration
  const handleCountdownExpire = useCallback(() => {
    setShowCountdown(false);
  }, []);

  if (showCountdown && targetDate) {
    return <Countdown targetDate={targetDate} onExpire={handleCountdownExpire} />;
  }

  // Temporary: Show centered message instead of wimmelbild
  return (
    <div className="flex items-center justify-center min-h-screen w-full">
      <p className="text-white text-center text-2xl md:text-4xl font-medium px-4">
        Bleibt gespannt und freut Euch auf das was kommt!
      </p>
    </div>
  );

  // TODO: Reactivate wimmelbild later
  // return (
  //   <OrientationPrompt>
  //     <ResponsiveFrame4 />
  //   </OrientationPrompt>
  // );
}

export default App;
